import { render, staticRenderFns } from "./TextField.form-builder.vue?vue&type=template&id=b4fd05e2&"
import script from "./TextField.form-builder.vue?vue&type=script&lang=js&"
export * from "./TextField.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports